import { useContext } from 'react';
import { AppConfigContext } from '../contexts/AppConfigContext';

// A custom hook allows us to test better.
export const useAppConfigContext = () => useContext(AppConfigContext);

export default useAppConfigContext;
